import React, { useState } from "react"
import { AdministrationOptions, Views } from "../interfaces"
import Add from "./Add"
import List from "./List"
import Edit from "./Edit"

interface ComponentsProps {
	section: AdministrationOptions
}

interface ViewsProps {
	section: AdministrationOptions
	setView: (value: Views) => void
	selection: any
	setSelection: (value: any) => void
}

const ComponentsViews: (
	props: ViewsProps
) => Record<Views, React.ReactElement> = (props) => ({
	List: <List {...props} />,
	Add: <Add {...props} />,
	Edit: <Edit {...props} />,
})

const Components: React.FC<ComponentsProps> = ({ section }) => {
	const [view, setView] = useState<Views>("List")
	const [selection, setSelection] = useState<any>(null)
	const component = ComponentsViews({
		section,
		setView,
		selection,
		setSelection,
	})
	return component[view]
}

export default Components
